import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = {
  class: "card-body p-10",
  style: {"background-color":"white"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Report Issue")
], -1)
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Subject"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, [
  /*#__PURE__*/_createTextVNode("Bug Type "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Definition: The research design of human subject research refers to the overall plan or strategy outlining how data will be collected and analyzed to address specific research questions or hypotheses."
  })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please specify"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Source URL"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Description")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary mb-1 col-2",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon fill-svg me-1" }),
  /*#__PURE__*/_createTextVNode(" Report ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form",
      id: "kt_modal_new_address_form",
      onSubmit: _ctx.submit,
      ref: "htmlForm",
      model: _ctx.step1,
      "validation-schema": _ctx.validationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Field, {
              type: "text",
              name: "subject",
              for: "subject",
              initialValue: "",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "Subject",
              modelValue: _ctx.step1.subject,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step1.subject) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "subject",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                (_openBlock(), _createBlock(_component_el_select, {
                  class: "form-select-solid",
                  placeholder: "Select option",
                  name: "researchDesign",
                  "data-control": "researchDesign",
                  modelValue: _ctx.step1.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.type) = $event)),
                  key: _ctx.step1.type
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Click On Button Nothing Happend",
                      value: "Click On Button Nothing Happend"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Click On Button Nothing Happend")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Navigation Problem",
                      value: "Navigation Problem"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Navigation Problem")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Data is not Loading",
                      value: "Data is not Loading"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Data is not Loading")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Control is not Showing Properly",
                      value: "Control is not Showing Properly"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Control is not Showing Properly")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "Others, please specify",
                      value: "Others, please specify"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Others, please specify")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              ])
            ]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "type",
              initialValue: "",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "How it will be record?",
              modelValue: _ctx.step1.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.type) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "type",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          (_ctx.step1.type == 'Others, please specify')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "other",
                  for: "other",
                  initialValue: "",
                  class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                  placeholder: "specify",
                  modelValue: _ctx.step1.other,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.other) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "other",
                  class: "fv-plugins-message-container invalid-feedback"
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Field, {
              type: "text",
              name: "sourceUrl",
              for: "sourceUrl",
              initialValue: "",
              regex: "/^(http|https):\\/\\/[w\\d]+\\.[\\w](\\/[\\w\\d]+)?$/",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "http://www.google.com",
              modelValue: _ctx.step1.sourceUrl,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.sourceUrl) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "sourceUrl",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_editor, {
              for: "purpose",
              initialValue: "",
              modelValue: _ctx.step1.description,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.description) = $event)),
              licenseKey: "gpl",
              "api-key": _ctx.currentEditorToken,
              init: {
              height: 200,
              menubar: false,
              base_url: '/tinymce',
              suffix: '.min',
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
            }, null, 8, ["modelValue", "api-key", "init"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "description",
              for: "description",
              initialValue: "",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "Type Purpose",
              modelValue: _ctx.step1.description,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.description) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "description",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]),
          _hoisted_14
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "model", "validation-schema"])
  ]))
}